const buildContactData = (contacts, selectedModeratorUserId) =>
  contacts
    .map(({ user }) => ({
      userId: user.id,
      avatar: user.avatar,
      initials: user.initials,
      fullNameWithTitle: user.fullNameWithTitle,
    }))
    .filter(c => selectedModeratorUserId !== c.userId);

export default buildContactData;
